// extracted by mini-css-extract-plugin
export default {"Modal":"Modal_Modal__S--ik","ModalCloseBtn":"Modal_ModalCloseBtn__fCGaz"};